// @ts-nocheck
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { authApi } from '@/services/api';
import {
  Plane,
  LayoutDashboard,
  Calendar,
  Settings,
  LogOut,
  User,
  Menu,
  X,
  History,
  Shield,
  RefreshCw,
  Eye,
  LayoutGrid,
  BarChart3,
  FileText,
  MapPin,
  Users,
  Briefcase,
  Globe,
} from 'lucide-react';
import { cn } from '@/utils/cn';
import { useState, useEffect } from 'react';

const scheduleNavigation = [
  { name: '仪表盘', href: '/dashboard', icon: LayoutDashboard },
  { name: '航班列表', href: '/flights', icon: Plane },
  { name: '日历视图', href: '/flights/calendar', icon: Calendar },
];

const syncNavigation = [
  { name: '同步中心', href: '/sync', icon: RefreshCw },
];

const fsopNavigation = [
  { name: '仪表盘', href: '/fsop', icon: BarChart3 },
  { name: '飞行记录', href: '/fsop/flightlogs', icon: Plane },
  { name: '视图配置', href: '/fsop/flightlogs/views', icon: LayoutGrid },
  { name: '航线地图', href: '/fsop/routeMap', icon: Globe },
];

const notesNavigation = [
  { name: '全部笔记', href: '/notes', icon: FileText },
  { name: '笔记广场', href: '/notes/plaza', icon: Globe },
];

const careerNavigation = [
  { name: '职业生涯', href: '/career', icon: Briefcase },
];

export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuthStore();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } finally {
      logout();
      navigate('/login');
    }
  };

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-900/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed top-0 left-0 z-50 h-full w-64 bg-white border-r border-gray-200 flex flex-col transition-transform duration-200 lg:translate-x-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        {/* Logo */}
        <div className="shrink-0 flex items-center gap-3 px-6 py-5 border-b border-gray-200">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
            <Plane className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-bold text-lg text-gray-900">FlightSync</h1>
            <p className="text-xs text-gray-500">Pro</p>
          </div>
          <button
            className="ml-auto lg:hidden p-2 hover:bg-gray-100 rounded-lg"
            onClick={() => setSidebarOpen(false)}
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Scrollable Navigation */}
        <div className="flex-1 overflow-y-auto min-h-0">

        {/* 航班日程 */}
        <div className="px-4 py-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            航班日程
          </p>
          <nav className="space-y-1">
            {scheduleNavigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-100'
                  )}
                  onClick={() => setSidebarOpen(false)}
                >
                  <item.icon className={cn('w-5 h-5', isActive ? 'text-blue-600' : 'text-gray-500')} />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* 数据同步 */}
        <div className="px-4 py-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            数据同步
          </p>
          <nav className="space-y-1">
            {syncNavigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-100'
                  )}
                  onClick={() => setSidebarOpen(false)}
                >
                  <item.icon className={cn('w-5 h-5', isActive ? 'text-blue-600' : 'text-gray-500')} />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* FSOP 管理 */}
        <div className="px-4 py-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            FSOP 管理
          </p>
          <nav className="space-y-1">
            {fsopNavigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-100'
                  )}
                  onClick={() => setSidebarOpen(false)}
                >
                  <item.icon className={cn('w-5 h-5', isActive ? 'text-blue-600' : 'text-gray-500')} />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* 笔记 */}
        <div className="px-4 py-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            笔记
          </p>
          <nav className="space-y-1">
            {notesNavigation.map((item) => {
              const isActive = item.href === '/notes'
                ? location.pathname === '/notes' ||
                  /^\/notes\/\d+/.test(location.pathname) ||
                  location.pathname === '/notes/new'
                : location.pathname === item.href || location.pathname.startsWith(`${item.href}/`);
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-100'
                  )}
                  onClick={() => setSidebarOpen(false)}
                >
                  <item.icon className={cn('w-5 h-5', isActive ? 'text-blue-600' : 'text-gray-500')} />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* 职业生涯 */}
        <div className="px-4 py-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            职业
          </p>
          <nav className="space-y-1">
            {careerNavigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-100'
                  )}
                  onClick={() => setSidebarOpen(false)}
                >
                  <item.icon className={cn('w-5 h-5', isActive ? 'text-blue-600' : 'text-gray-500')} />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* 管理员功能 - 仅 staff 可见 */}
        {user?.isStaff && (
          <div className="px-4 py-2">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
              系统管理
            </p>
            <nav className="space-y-1">
              <Link
                to="/admin/subscription"
                className={cn(
                  'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                  location.pathname === '/admin/subscription'
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-100'
                )}
                onClick={() => setSidebarOpen(false)}
              >
                <Shield className={cn('w-5 h-5', location.pathname === '/admin/subscription' ? 'text-blue-600' : 'text-gray-500')} />
                订阅管理
              </Link>
            </nav>
          </div>
        )}

        {/* 设置 */}
        <div className="px-4 py-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            系统
          </p>
          <nav className="space-y-1">
            <Link
              to="/settings"
              className={cn(
                'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                location.pathname === '/settings'
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-gray-700 hover:bg-gray-100'
              )}
              onClick={() => setSidebarOpen(false)}
            >
              <Settings className={cn('w-5 h-5', location.pathname === '/settings' ? 'text-blue-600' : 'text-gray-500')} />
              设置
            </Link>
          </nav>
        </div>
        </div>

        {/* User section */}
        <div className="shrink-0 p-4 border-t border-gray-200 bg-white">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
              <User className="w-5 h-5 text-blue-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">
                {user?.displayName || user?.username}
              </p>
              <p className="text-xs text-gray-500 truncate">{user?.email}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <LogOut className="w-4 h-4" />
            退出登录
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="lg:ml-64 lg:min-h-screen flex flex-col h-[100dvh] overflow-hidden lg:h-auto lg:overflow-visible">
        {/* Mobile header */}
        <header className="lg:hidden shrink-0 flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(true)}
              className="p-2 hover:bg-gray-100 rounded-lg"
            >
              <Menu className="w-6 h-6" />
            </button>
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
              <Plane className="w-5 h-5 text-white" />
            </div>
          </div>
        </header>

        {/* Page content */}
        <div className="flex-1 overflow-y-auto p-6 lg:flex-initial lg:overflow-visible">
          <Outlet />
        </div>
        <footer className="shrink-0 py-2 px-4 text-xs text-gray-400 border-t border-gray-100 text-center">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-600 transition-colors"
          >
            渝ICP备2026015661号
          </a>
        </footer>
      </main>
    </div>
  );
}
